import { render, staticRenderFns } from "./addTelegram.vue?vue&type=template&id=ad37a538&scoped=true"
import script from "./addTelegram.vue?vue&type=script&lang=js"
export * from "./addTelegram.vue?vue&type=script&lang=js"
import style0 from "./addTelegram.vue?vue&type=style&index=0&id=ad37a538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad37a538",
  null
  
)

export default component.exports